import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, HostListener } from '@angular/core';
import { Permission, Role, canManageStaffRole } from '../permissions/permissions';
import { MatDialog } from '@angular/material/dialog';
import { PermissionDeniedDialogComponent } from '../permissions/permission-denied-dialog.component';
import { environment } from 'src/environments/environment';
import { RoutesService } from 'src/app/buses/_services/routes.service';
import { GlobalService } from 'src/app/_services/global.service';
import { BusStudentsService } from 'src/app/buses/_services/bus-students.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { MessagesControlService } from 'src/app/_services/messages-control.service';
import { ControlDeletionService } from 'src/app/_services/control-deletion.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSnackBar } from '@angular/material/snack-bar';
import moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-table-view',
  templateUrl: './table-view.component.html',
  styleUrls: ['./table-view.component.scss'],
  animations: [
    trigger('sidebarAnimation', [
      state('hidden', style({
        width: '0',
        opacity: '0'
      })),
      state('visible', style({
        width: '50px',
        opacity: '1'
      })),
      transition('hidden => visible', animate('300ms ease-in')),
      transition('visible => hidden', animate('300ms ease-out'))
    ])
  ]
})
export class TableViewComponent implements OnInit {
  @Input("controls") controls;
  @Input() paginatorInfo: any;
  @Output("eventHandeler") eventHandeler = new EventEmitter();
  @Output() onPaginationBtnClick = new EventEmitter();
  @Input() selectedUsersIDS: any;
  @Input() listType;
  @Output() generateExcel = new EventEmitter<boolean>();
  @Output() printQr = new EventEmitter<boolean>();
  @Input() selectedRows_from_component;
  // When true, the selected-count chip shows the parent's full selection (all pages / filters)
  // instead of only the rows selected on the current page.
  @Input() countSelectionAcrossPages = false;
  @Input() report_type;
  @Input() showExport = false;
  @Input() showExportPreparingToaster = true;
  @Input() showPrintQr = false;
  @Input() showDeleteIcon = false;
  @Input() showMsgIcon = false;
  @Input() showRegenerateQrIcon = false;
  @Input() showSideBar = true;
  @Input() showMonthDropdownFilter = false;
  @Input() monthDropdownValues = [];
  @Output() selcetedMonthYear = new EventEmitter<any>();
  @Input() studentAttendanceReport = false;

  rowsNumberToBeShowed;
  sortingOrder;
  sortedCol;
  columns = [];
  data = [];
  noResultsFlag: boolean = false;
  view = "list";
  selection = true;
  selectionAll = true;
  sortingIndex = false;
  showSelectionNumberFlag = true;
  singleSelect = true;
  pagination;
  showPagination:boolean;
  AllRowsIsChecked = false;
  selectedRows = [];
  selectedCount = 0;
  loading = false;
  currLang;
  tableTitle = '';
  selectedTitle = '';
  totalTitle = '';
  @Input() showPaginatian: boolean = false;
  @Input() currentView: string = "list";
  @Input() sortingIndexRow: boolean = false;
  // ===== Expansion feature: public inputs/state/API =====
  // When true, the table renders a small "View Detail" button in each row and supports an extra details row below it.
  @Input() allowRowExpand: boolean = false;
  // Optional injected template from parent. If provided, it renders inside the details row.
  // Kept typed as any to avoid importing TemplateRef here and keep the component self-contained.
  @Input() rowDetailsTemplate: any;
  // Tracks the currently expanded row index (-1 means no row expanded). Only one row is expanded at a time.
  expandedRowIndex: number = -1;
  // Small API surface exposed to the injected template (via ngTemplateOutlet context) so templates can emit actions
  // back through the table using the existing event output (eventHandeler). This avoids creating new Outputs per use case.
  templateApi = {
    // Notify parent that a resolution choice has been made from the expanded panel
    applyResolution: (rowIndex: number, row: any, payload: any) => this.applyResolution(rowIndex, row, payload)
  };

  clearAllSubscription;
  clearSingleSubscription;
  chaeckAllSubscription;
  clearSingleStuSubscription;
  clearSingleStuSubscription2;
  showDeleteBtn: boolean;
  showMessageBtn: boolean;
  rowsSubscription: Subscription;
  msgSubscription: Subscription;
  deleteSubscription: Subscription;
  selectedMonth: string ;
  maxSelectableDate: Date;
  
  // Quick Actions properties
  activeQuickActionsIndex: number = -1;
  // Assigned entities dropdowns per row
  activeFirstAssignedIndex: number = -1;
  activeMoreAssignedIndex: number = -1;
  // Parents dropdown per row
  activeParentDropdownIndex: number = -1;
  // Students dropdown per row
  activeStudentDropdownIndex: number = -1;
  // Copy to clipboard state
  copiedCellKey: string = null;

  constructor(private routesService: RoutesService, private globalService: GlobalService,
    private translate: TranslateService, private busesStudentsService: BusStudentsService,
    private qrControl: ControlQrService,
    private messagesControlService: MessagesControlService,
    private controlDeletion: ControlDeletionService,
    private router: Router,
    private dataService: DataService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    ) {
  }

  ngOnInit(): void {
    this.clearAllSubscription = new Subscription();
    this.clearSingleSubscription = new Subscription();
    this.chaeckAllSubscription = new Subscription();
    this.clearSingleStuSubscription = new Subscription();
    this.clearSingleStuSubscription2 = new Subscription();
    this.rowsSubscription = new Subscription();
    this.msgSubscription = new Subscription();
    this.deleteSubscription = new Subscription();
    this.maxSelectableDate = moment().endOf('month').toDate();

    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    let clearSingleStu = this.busesStudentsService.getClearSingleStudent().subscribe((res: any) => {
      if (res !== null) {
        res.student.isSelected = true;
        this.checkboxAction({ checked: false }, res.student, res.toBeUncehckedStudent)
      }
    })
    this.clearSingleStuSubscription.add(clearSingleStu);

    let clearSingleStu2 = this.routesService.getClearSingleStudent().subscribe((res: any) => {
      if (res !== null) {
        res.student.isSelected = true;
        this.checkboxAction({ checked: false }, res.student, res.toBeUncehckedStudent);
      }
    })
    this.clearSingleStuSubscription2.add(clearSingleStu2);

    let clearAll = this.busesStudentsService.getClearAllStudents().subscribe((res: any) => {
      
      if (res) {
        this.AllRowsIsChecked = false;
        this.checkBoxSelectAll({ checked: false })
      }
    })
    this.clearAllSubscription.add(clearAll);

    let clearSingle = this.routesService.getClearAllStudents().subscribe((res: any) => {
      if (res) {
        this.AllRowsIsChecked = false;
        this.checkBoxSelectAll({ checked: false })
      }
    })
    this.clearSingleSubscription.add(clearSingle);

    let checkall = this.routesService.getCheckAllBtn().subscribe((res: any) => {
      if (res !== null) {
        this.AllRowsIsChecked = res;
      }
    })
    this.chaeckAllSubscription.add(checkall);
    setTimeout(() => {
    }, 2000)

    let getDelBtn = this.controlDeletion.getDeleteBtnCondition().subscribe(res => {
      this.showDeleteBtn = res;
      console.log('deleteBtn', this.showDeleteBtn);
    })
    this.deleteSubscription.add(getDelBtn);

    let getMsgBtn = this.messagesControlService.getMessageBtnCondition().subscribe(res => {
      this.showMessageBtn = res;
      console.log('messsageBtn', this.showMessageBtn);
    })
    this.msgSubscription.add(getMsgBtn);

    let getRows = this.dataService.getRowsNumberShown().subscribe(res => {
      console.log('getrowres', res);
      this.rowsNumberToBeShowed = res;
    })
    this.rowsSubscription.add(getRows);
    console.log('rowsSubscription',this.rowsSubscription);
  }

  skipBulkImportError(event: Event, rowIndex: number) {
    this.eventHandeler.emit({
      action: "skipBulkImportError",
      target: { index: rowIndex, data: this.data?.[rowIndex] }
    });
  }

  undoBulkImportError(event: Event, rowIndex: number) {
    if (event) { event.stopPropagation(); }
    this.eventHandeler.emit({
      action: "undoBulkImportError",
      target: { index: rowIndex, data: this.data?.[rowIndex] }
    });
  }
  // ===== Expansion feature: controller methods =====
  // Toggle expand/collapse for a given row. Emits a semantic event for parents (e.g., to lazy-load details on demand).
  toggleRowExpand(event: Event, rowIndex: number) {
    if (event) { event.stopPropagation(); } // Prevent checkbox/row click side effects
    // Toggle: if clicking the same row, collapse; otherwise expand the new row
    this.expandedRowIndex = this.expandedRowIndex === rowIndex ? -1 : rowIndex;
    // Inform parent components (analytics, data fetching, etc.)
    this.eventHandeler.emit({
      action: "rowExpandToggled",
      target: { index: rowIndex, data: this.data?.[rowIndex] },
      expanded: this.expandedRowIndex === rowIndex
    });
  }

  // Emit a high-level intent that a user selected a value (e.g., "Use This") from the expanded view.
  // Parents can listen on (eventHandeler) and call backend endpoints with the payload.
  applyResolution(rowIndex: number, row: any, payload: any) {
    this.eventHandeler.emit({
      action: "applyResolution",
      target: { index: rowIndex, data: row },
      payload
    });
  }
  bulkImportStudentRequestTransfer(event: Event, row: any) {
    if (row.status === 'pending') {
    this.eventHandeler.emit({
      action: "bulkImportStudentRequestTransfer",
      target: { index: row.index, data: row }
    });
    }
  }

  // Compute how many table columns are visible for the current configuration so the details row can span them all.
  getDetailColspan(): number {
    const baseCols = Array.isArray(this.columns) ? this.columns.length : 0;
    const selectionCol = this.selection ? 1 : 0;     // checkbox column
    const sortingIndexCol = this.sortingIndex ? 1 : 0; // sortable index column
    return baseCols + selectionCol + sortingIndexCol;
  }

  getDeletePermissionForList(): Permission | null {
    switch (this.listType) {
      case 'students':
        return Permission.StudentDelete;
      case 'parents':
        return Permission.ParentDelete;
      case 'staff':
        return Permission.StaffDelete;
      default:
        return null; // No guard for other lists
    }
  }

  getEditPermissionForList(): Permission | null {
    switch (this.listType) {
      case 'staff':
        return Permission.StaffEdit;
      default:
        return null; // No guard for other lists
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.tableTitle = this.controls?.title;
    this.selectedTitle = this.controls?.selectedTitle;
    this.totalTitle = this.controls?.totalTitle
    this.selection = this.controls.selection;
    this.selectionAll = this.controls.selection;
    this.sortingIndex = this.controls.sortingIndex
    this.showSelectionNumberFlag = this.controls?.showSelectionNumberFlag == null ? true : this.controls?.showSelectionNumberFlag;
    this.singleSelect = this.controls.singleSelect;
    this.selectedRows = (new Array(this.controls?.data?.length)).fill(false);
    this.selectedCount = 0;
    this.pagination = this.controls.pagination;
    this.showPagination = this.controls.paging;
    this.view = this.controls.view;
    this.columns = this.controls.columns;
    this.data = this.controls.data;
    console.log('controls: ', this.controls);
    console.log('data: ', this.data);    
    if (this.data?.length == 0) {
      this.noResultsFlag = true
    }
    else {
      this.noResultsFlag = false
    }
    this.AllRowsIsChecked = false;
    if (changes.currentView) {
      if (changes.currentView.currentValue != changes.currentView.previousValue) {
        this.view = changes.currentView.currentValue;
      }
    }

    this.data?.forEach((element, index) => {
      if (element.isSelected) {
        this.selectedRows[index] = true;
      }
    });
    this.addSelectedFlagToUsers();
    this.getSelectionCount();
    // console.log(this.data);    

  }
  addSelectedFlagToUsers() {
    this.data?.forEach((element, index) => {
      if (this.selectedUsersIDS?.includes(element.id)) {
        element["isSelected"] = true;
        this.selectedRows[index] = true;
      }
    });
  }

  rowClicked(row, index) {
    this.eventHandeler.emit(
      {
        action: "rowClicked",
        target:
        {
          index: index,
          data: row
        }
      }
    );
  }
  iconClicked(event, row, index) {
    this.eventHandeler.emit(
      {
        action: "iconClicked",
        e: event,
        target:
        {
          index: index,
          data: row
        }
      }
    );
  }

  addAssistantClicked(event, row, index) {
    event.stopPropagation();
    this.eventHandeler.emit(
      {
        action: "AddAssistantClicked",
        e: event,
        target:
        {
          index: index,
          data: row
        }
      }
    );
  }

  deleteIconClicked(event, row, index) {
    event.stopPropagation();
    this.eventHandeler.emit(
      {
        action: "DeleteIconClicked",
        e: event,
        target:
        {
          index: index,
          data: row
        }
      }
    );
  }

  actionBtnClicked(event, row, index , btn_type) {
    this.eventHandeler.emit(
      {
        action: `${btn_type}Clicked`,
        e: event,
        target:
        {
          index: index,
          data: row
        }
      }
    );
  }

  seeMoreIconClicked(event, row, index , col) {
    this.eventHandeler.emit(
      {
        action: "iconClicked",
        e: event,
        target:
        {
          index: index,
          data: row,
          col: col
        }
      }
    );
  }

  colGroupItemClicked(event , row , index , item , itemIndex){
    this.eventHandeler.emit(
      {
        action: "colGroupItemClicked",
        e:event,
        target:
        {
          index: index,
          data: row,
          item_data:item,
          item_index:itemIndex
        }
      }
    );   
  }

  continueBulkProcess(event, row, index) {
    this.eventHandeler.emit(
      {
        action: "continueBulkProcess",
        e: event,
        target:
        {
          index: index,
          data: row
        }
      }
    );
  }

  checkBoxSelectAll(event) {
    this.AllRowsIsChecked = event.checked;
    this.data.forEach(element => {
      element.isSelected = this.AllRowsIsChecked;
    });
    this.selectedRows.fill(this.AllRowsIsChecked);
    this.eventHandeler.emit(
      {
        action: "checkboxChanged",
        target:
        {
          index: "all",
          data: "all",
          dataValues: this.data,
          checked: event.checked
        }
      }
    );
    this.getSelectionCount();
  }

  checkboxAction(event, row, index) {
    if (this.singleSelect) {
      this.selectedRows.fill(false);
      this.data.forEach(element => {
        element.isSelected = false;
      });
    }
    row.isSelected = !row.isSelected;
    this.selectedRows[index] = event.checked;

    if (this.selectedRows.includes(false)) {
      this.AllRowsIsChecked = false;
    }
    this.eventHandeler.emit(
      {
        action: "checkboxChanged",
        target:
        {
          index: index,
          data: row,
          checked: event.checked
        }
      }
    );
    this.getSelectionCount()
  }
  changeActivation(event, row, index) {
    this.eventHandeler.emit(
      {
        action: "activationChanged",
        e: event,
        target:
        {
          index: index,
          data: row,
        }
      }
    );
  }

  showQR(event, row, index) {
    this.eventHandeler.emit(
      {
        action: "showQr",
        e: event,
        target:
        {
          index: index,
          data: row,
        }
      }
    );
  }

  sortIndex(row, order, index) {
    this.eventHandeler.emit(
      {
        action: "sortingIndexRow",
        target:
        {
          data: row,
          order: order,
          index: index
        }
      }
    );


  }
  sort(col, order) {
    this.sortingOrder = order;
    this.sortedCol = col;
    this.eventHandeler.emit(
      {
        action: "sorting",
        target:
        {
          source: col.source,
          order: order
        }
      }
    );
  }
  linkClicked(row, col, index) {
    if (row[col.source + '_link'] == true) {
      this.eventHandeler.emit(
        {
          action: "linkClicked",
          target:
          {
            source: col.source,
            row: row,
            index: index
          }
        }
      );
    }
  }

  viewAttendancePerformance(event, row, index) {
    event.stopPropagation();
    this.eventHandeler.emit(
      {
        action: "viewAttendancePerformance",
        target: { row: row, index: index }
      }
    );
  }

  changeTime(row, col, index, event) {
    this.eventHandeler.emit(
      {
        action: "timeChanged",
        target:
        {
          source: col.source,
          row: row,
          index: index,
          time: event.target.value
        }
      }
    );
  }

  getImage(imagePath: string) {
    return environment.img_url + imagePath;
  }
  paginationHandler(value) {
    this.onPaginationBtnClick.emit(value)
  }

  paginationChange(direction) {
    if ((direction == 1 && this.pagination.to != this.pagination.total) || (direction == -1 && this.pagination.from != 1)) {
      this.eventHandeler.emit(
        {
          action: "pagination",
          target:
          {
            dir: direction
          }
        }
      );
    }
  }

  checkColumn(type, view) {
    let result = type === 'image' && view === 'compact' ? false : true;
    return result;
  }

  getSelectionCount() {
    this.selectedCount = this.selectedRows.filter(row => row == true).length;
  }

  // Clears the whole selection (including rows on other pages / filtered out); the parent owns the full list.
  clearSelection() {
    this.data?.forEach(element => element.isSelected = false);
    this.selectedRows.fill(false);
    this.AllRowsIsChecked = false;
    this.getSelectionCount();
    this.eventHandeler.emit({ action: "clearSelection", target: {} });
  }

  // Header "select all" checkbox mirrors the rows themselves, so it can never drift out of sync
  // (e.g. after clear-all, unchecking rows one by one, or paging back to a fully selected page).
  get allShownRowsSelected(): boolean {
    return !!this.data?.length && this.data.every(row => row.isSelected);
  }

  get displayedSelectedCount(): number {
    return this.countSelectionAcrossPages && this.selectedRows_from_component
      ? this.selectedRows_from_component.length
      : this.selectedCount;
  }

  onScroll(event) {
    if (event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight) {
      this.eventHandeler.emit(
        {
          action: "scroll",
          target:
          {
            event: event
          }
        }
      );
    }
  }

  toggleSortingIndex() {
    this.sortingIndexRow = !this.sortingIndexRow;
    this.eventHandeler.emit(
      {
        action: "sortingIndex",
        target:
        {
          toggleIndex: this.sortingIndexRow,
        }
      }
    );
  }

  radioButtonClicked(event , row , type){
    row.present = row.absent = row.late = false;
    switch (type) {
      case 'present':
        row.present = event.target.checked ?  true : false;
        row.cutedNote = row.note = null;
        break;

        case 'absent':
          row.absent = event.target.checked ?  true : false;
        break;

        case 'late':
          row.late = event.target.checked ?  true : false;
        break;
    
    }
  } 
    
  truncate(str, n){
    return (str?.length > n) ? str.slice(0, n-1) + '....' : str;
  };

  ngOnDestroy(): void {
    this.clearAllSubscription.unsubscribe();
    this.clearSingleSubscription.unsubscribe();
    this.chaeckAllSubscription.unsubscribe();
    this.clearSingleStuSubscription.unsubscribe();
    this.clearSingleStuSubscription2.unsubscribe();
    this.rowsSubscription.unsubscribe();
    this.deleteSubscription.unsubscribe();
    this.msgSubscription.unsubscribe();
  }

  // Validation tooltip properties
  activeValidationTooltipIndex: string = '';

  // Validation error handling methods
  showValidationTooltip(event: MouseEvent, rowIndex: number, colIndex: number) {
    this.activeValidationTooltipIndex = `${rowIndex}-${colIndex}`;

    setTimeout(() => {
      const rect = (event.target as HTMLElement).getBoundingClientRect();
      const tooltip = document.querySelector('.validation-tooltip') as HTMLElement;
      if (!tooltip) return;
  
      const tooltipRect = tooltip.getBoundingClientRect();
  
      tooltip.style.top = rect.bottom + 'px';
      
      // Center the tooltip relative to the element (works for both RTL and LTR)
      tooltip.style.left = rect.left + (rect.width / 2) - (tooltipRect.width / 2) + 'px';
    });
  }

  hideValidationTooltip() {
    this.activeValidationTooltipIndex = '';
  }

  getLocalizedCriteria(fieldName: string): string[] {
    console.log('fieldName' , fieldName);
    const schoolCountryCode = localStorage.getItem('schoolCountryCode');
    const criteriaMap: { [key: string]: string[] } = {
      'name': [
        this.translate.instant('validation-tooltip.student_name.criteria1'),
        this.translate.instant('validation-tooltip.student_name.criteria2'),
        this.translate.instant('validation-tooltip.student_name.criteria3')
      ],
      'national_id': [
        this.translate.instant('validation-tooltip.student_national_id.criteria1'),
        this.translate.instant('validation-tooltip.student_national_id.criteria2'),
        this.translate.instant('validation-tooltip.student_national_id.criteria3'),
        this.translate.instant('validation-tooltip.student_national_id.criteria4')
      ],
      'gender': [
        this.translate.instant('validation-tooltip.student_gender.criteria1'),
        this.translate.instant('validation-tooltip.student_gender.criteria2'),
      ],
      'grade': [
        this.translate.instant('validation-tooltip.grade_name.criteria1'),
        this.translate.instant('validation-tooltip.grade_name.criteria2'),
        this.translate.instant('validation-tooltip.grade_name.criteria3')
      ],
      'class': [
        this.translate.instant('validation-tooltip.class_name.criteria1'),
        this.translate.instant('validation-tooltip.class_name.criteria2'),
        this.translate.instant('validation-tooltip.class_name.criteria3')
      ],
      'parent_name': [
        this.translate.instant('validation-tooltip.parent_name.criteria1'),
        this.translate.instant('validation-tooltip.parent_name.criteria2'),
        this.translate.instant('validation-tooltip.parent_name.criteria3')
      ],
      'parent_phone': [
        this.translate.instant('validation-tooltip.parent_phone.criteria1'),
        this.translate.instant('validation-tooltip.parent_phone.criteria2'),
        this.translate.instant('validation-tooltip.parent_phone.criteria3'),
      ],
      'parent_national_id': [
        this.translate.instant('validation-tooltip.parent_national_id.criteria1'),
        this.translate.instant('validation-tooltip.parent_national_id.criteria2'),
        this.translate.instant('validation-tooltip.parent_national_id.criteria3'),
      ],
      'parent_gender': [
        this.translate.instant('validation-tooltip.parent_gender.criteria1'),
        this.translate.instant('validation-tooltip.parent_gender.criteria2'),
      ],
      'parent_email': [
        this.translate.instant('validation-tooltip.parent_email.criteria1'),
        this.translate.instant('validation-tooltip.parent_email.criteria2'),
        this.translate.instant('validation-tooltip.parent_email.criteria3'),
      ]
    };

    if (fieldName === 'parent_phone') {
      const phoneLengthCriteriaMap: { [key: string]: string } = {
        "+974": this.translate.instant('validation-tooltip.parent_phone.length.qa'),
        "+962": this.translate.instant('validation-tooltip.parent_phone.length.jo'),
        "+971": this.translate.instant('validation-tooltip.parent_phone.length.ae'),
        "+973": this.translate.instant('validation-tooltip.parent_phone.length.bh'),
        "+968": this.translate.instant('validation-tooltip.parent_phone.length.om'),
        "+965": this.translate.instant('validation-tooltip.parent_phone.length.kw'),
        "+964": this.translate.instant('validation-tooltip.parent_phone.length.iq'),
        "+20": this.translate.instant('validation-tooltip.parent_phone.length.eg'),
        "+966": this.translate.instant('validation-tooltip.parent_phone.length.sa')
      };

      const countrySpecificCriteria =
        schoolCountryCode && phoneLengthCriteriaMap[schoolCountryCode];

      return [
        ...criteriaMap.parent_phone,
        countrySpecificCriteria ||
        this.translate.instant('validation-tooltip.parent_phone.length.default')
      ];
    }

    return criteriaMap[fieldName];
  }

  generateExcelFile(value: boolean) {
    if(this.showExportPreparingToaster){
      this.globalService.setExportAlert('preparing');
    }
    this.generateExcel.emit(value)
  }

  printQrCodes(value: boolean) {
    let qrObj:any= {}
    qrObj.type = this.listType;
    qrObj.selected = this.selectedRows_from_component;
    qrObj.showPrint = value;
    this.printQr.emit(qrObj)
  }

  regenerateCodes(event , row , index) {
    event.stopPropagation();
    console.log('event' , event);
    console.log('row' , row);
    console.log('index' , index);
    this.qrControl.setRegenerateUserData(row);
    // this.qrControl.setParentsData(this.selectedRows_from_component, 'multi');
    $("#confirmModal").modal("show");
  }

  sendMessage() {
    let users = this.selectedRows_from_component;
    switch (this.listType) {
      case 'students':
        users = users.map(student => {
          return student.users[0]
        });
        break;

      case 'bus-students':
        users = users.map(student => {
          return student.parent_data
        });
        break;
      default:
        break;
    }
    this.messagesControlService.setMessagedRows(users);
    this.router.navigateByUrl('/messages/create-messages');
  }

  openDeleteModal() {
    // bulk delete: one School Admin in the selection blocks the whole delete for roles without StaffManageSchoolAdmin
    const loginAs = (localStorage.getItem('loginAs') || '').trim() as Role;
    if (this.listType === 'staff'
      && (this.selectedRows_from_component || []).some(row => !canManageStaffRole(loginAs, row?.role))) {
      this.dialog.open(PermissionDeniedDialogComponent, { width: '400px' });
      return;
    }
    let body = { 'noOfShownRows': this.rowsNumberToBeShowed, 'type': this.listType, 'rows_array': this.selectedRows_from_component }
    console.log('deleteBody', body);
    this.controlDeletion.setDeletedRows(body)
    $("#deleteModal").modal("show");
  }

  toggleTableBorderRadius(flag1, flag2 , lng , type){
    const borderRadius = {};
    if (type === 'heading') {
        if (!flag1 && !flag2) {
            borderRadius['border-top-left-radius'] = '10px';
            borderRadius['border-top-right-radius'] = '10px';
        } else if ((flag1 || flag2) && lng === 'en') {
            borderRadius['border-top-right-radius'] = '10px';
        } else if ((flag1 || flag2) && lng === 'ar') {
            borderRadius['border-top-left-radius'] = '10px';
        }
    } else if (type === 'footer') {
        if (!flag1 && !flag2) {
            borderRadius['border-bottom-left-radius'] = '10px';
            borderRadius['border-bottom-right-radius'] = '10px';
        } else if ((flag1 || flag2) && lng === 'en') {
            borderRadius['border-bottom-right-radius'] = '10px';
        } else if ((flag1 || flag2) && lng === 'ar') {
            borderRadius['border-bottom-left-radius'] = '10px';
        }
    }
    return borderRadius;
  }
  
  emitMonthYear(event){
    if(event) {
      const formatedDate = moment(event).startOf('month').format('YYYY-MM-DD');
      this.selcetedMonthYear.emit(formatedDate)
    }
    else{
      this.selcetedMonthYear.emit(null)
    }
  }

  // Quick Actions Methods
  toggleQuickActions(event: Event, rowIndex: number) {
    event.stopPropagation();
    
    if (this.activeQuickActionsIndex === rowIndex) {
      this.activeQuickActionsIndex = -1;
    } else {
      this.activeQuickActionsIndex = rowIndex;
    }
  }

  onQuickAction(event: Event, action: string, row: any, rowIndex: number) {
    this.activeQuickActionsIndex = -1;
    
    // Emit the action to the parent component
    this.eventHandeler.emit({
      action: action,
      e: event,
      target: {
        index: rowIndex,
        data: row
      },
      type: 'quick-action'
    });
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (this.activeQuickActionsIndex !== -1) {
      this.activeQuickActionsIndex = -1;
    }
    if (this.activeFirstAssignedIndex !== -1) {
      this.activeFirstAssignedIndex = -1;
    }
    if (this.activeMoreAssignedIndex !== -1) {
      this.activeMoreAssignedIndex = -1;
    }
    if (this.activeParentDropdownIndex !== -1) {
      this.activeParentDropdownIndex = -1;
    }
    if (this.activeStudentDropdownIndex !== -1) {
      this.activeStudentDropdownIndex = -1;
    }
  }
  
  goToStudentAttendanceReport() {
    this.router.navigateByUrl('/attendance/reports/search-student-attendance');
  }

  // display-only: row.role stays the raw backend value (other logic keys off it)
  getRoleLabel(role: string): string {
    if (!role) { return role; }
    const key = `roles.${role}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : role;
  }

  // Assigned entities helpers
  isRoleWithEntities(role: string): boolean {
    if (!role) { return false; }
    const r = (role || '').toString().toLowerCase();
    return r === 'teacher' || r === 'supervisor' || r === 'security' || r === 'shared_gate_scanner' || r === 'gate';
  }

  getEntities(row: any): any[] {
    if (!row) { return []; }
    const role = (row?.role || '').toString().toLowerCase();
    if (role === 'teacher') { return row?.classes || []; }
    if (role === 'supervisor') { return row?.grades || []; }
    if (role === 'security' || role === 'shared_gate_scanner' || role === 'gate') { return row?.gates || []; }
    return [];
  }

  getEntityName(entity: any): string {
    if (entity == null) { return ''; }
    return entity?.name || entity?.class_name || entity?.grade_name || entity?.gate_name || entity?.title || entity?.label || entity?.toString();
  }

  toggleFirstAssignedDropdown(event: Event, rowIndex: number) {
    event.stopPropagation();
    this.activeFirstAssignedIndex = this.activeFirstAssignedIndex === rowIndex ? -1 : rowIndex;
    // ensure other dropdown is closed
    if (this.activeFirstAssignedIndex !== -1) {
      this.activeMoreAssignedIndex = -1;
    }
  }

  toggleMoreAssignedDropdown(event: Event, rowIndex: number) {
    event.stopPropagation();
    this.activeMoreAssignedIndex = this.activeMoreAssignedIndex === rowIndex ? -1 : rowIndex;
    // ensure other dropdown is closed
    if (this.activeMoreAssignedIndex !== -1) {
      this.activeFirstAssignedIndex = -1;
    }
  }

  // Parents column helpers
  getParents(row: any): any[] {
    return row?.parents || [];
  }

  getParentName(parent: any): string {
    if (parent == null) { return ''; }
    return parent?.name || '';
  }

  getParentNamesArray(row: any): any[] {
    return row?.parent_names || [];
  }

  toggleParentDropdown(event: Event, rowIndex: number) {
    event.stopPropagation();
    this.activeParentDropdownIndex = this.activeParentDropdownIndex === rowIndex ? -1 : rowIndex;
  }

  // Students column helpers (for parent table)
  getStudentNamesArray(row: any): any[] {
    return row?.students_name || [];
  }

  toggleStudentDropdown(event: Event, rowIndex: number) {
    event.stopPropagation();
    this.activeStudentDropdownIndex = this.activeStudentDropdownIndex === rowIndex ? -1 : rowIndex;
  }

  // Copy to clipboard helpers
  copyToClipboard(event: Event, value: string, rowIndex: number, colSource: string) {
    event.stopPropagation();
    navigator.clipboard.writeText(value);

    this._snackBar.open(
      this.translate.instant('table-view.copied-to-clipboard'),
      '',
      {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['copy-success-snackbar']
      }
    );

    this.copiedCellKey = `${rowIndex}-${colSource}`;
  }

  isCopied(rowIndex: number, colSource: string): boolean {
    return this.copiedCellKey === `${rowIndex}-${colSource}`;
  }

  onCopyAnimationEnd() {
    this.copiedCellKey = null;
  }
}
